(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["em-cart-boost"]) return;
  try {
    
(function(){
  if (window.EMCart) return;
  var root = document.querySelector('[data-emc]');
  var cfgEl = document.querySelector('[data-emc-config]');
  if (!root || !cfgEl) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var $ = function(s){ return root.querySelector(s); };
  var card = $('.emc__card');
  var lastFocus = null, closeTimer = null, lastAddedTitle = '';

  function money(cents){
    var fmt = cfg.moneyFormat || '€{{amount_with_comma_separator}}';
    var n = (Number(cents) || 0) / 100;
    var parts = function(dec, th, ds){ var f = n.toFixed(dec).split('.'); f[0] = f[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return f.join(ds); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      switch (k) {
        case 'amount_with_comma_separator': return parts(2, '.', ',');
        case 'amount_no_decimals': return parts(0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return parts(0, '.', ',');
        case 'amount_with_apostrophe_separator': return parts(2, "'", '.');
        case 'amount_with_space_separator': return parts(2, ' ', ',');
        default: return parts(2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  function open(){
    clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.add('is-open'); card.focus({ preventScroll: true }); }); });
  }
  function close(){
    root.classList.remove('is-open');
    closeTimer = setTimeout(function(){ root.hidden = true; }, 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  root.querySelectorAll('[data-emc-close]').forEach(function(b){ b.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  function updateHeaderCount(n){
    document.querySelectorAll('.pet-cart span, [data-cart-count]').forEach(function(el){ el.textContent = n; });
  }

  function render(cart){
    var guides = 0, inCart = {}, lastDog = false, lastCat = false;
    cart.items.forEach(function(it){
      inCart[it.product_id] = true;
      if (it.product_type === cfg.guideType) guides += it.quantity;
    });
    var latest = cart.items[0];
    if (latest) {
      var g = cfg.guides.filter(function(x){ return x.id === latest.product_id; })[0];
      if (g) { lastDog = g.dog; lastCat = g.cat; }
    }
    $('[data-emc-item]').textContent = lastAddedTitle || (latest ? latest.product_title : '');
    $('[data-emc-count]').textContent = cart.item_count;
    updateHeaderCount(cart.item_count);

    /* bundle progress */
    var bundle = $('[data-emc-bundle]');
    bundle.hidden = guides < 1;
    if (guides >= 1) {
      var key = guides >= 3 ? 'three' : guides === 2 ? 'two' : 'one';
      $('[data-emc-msg]').textContent = cfg.msg[key];
      var pct = guides >= 3 ? 100 : guides === 2 ? 50 : 0;
      bundle.querySelector('[data-emc-fill]').style.setProperty('--p', '0%');
      requestAnimationFrame(function(){ bundle.querySelector('[data-emc-fill]').style.setProperty('--p', pct + '%'); });
      bundle.querySelectorAll('[data-step]').forEach(function(el){ el.classList.toggle('is-on', Number(el.dataset.step) <= Math.min(guides, 3)); });
    }

    /* one suggestion: a guide not in cart, same pet first, cheapest first when it unlocks a tier */
    var pool = cfg.guides.filter(function(x){ return !inCart[x.id]; });
    var same = pool.filter(function(x){ return (lastDog && x.dog) || (lastCat && x.cat); });
    var pick = (same.length ? same : pool)[0];
    var sug = $('[data-emc-suggest]');
    if (pick && guides >= 1 && guides < 3) {
      sug.hidden = false;
      sug.querySelectorAll('[data-emc-s-link]').forEach(function(a){ a.href = pick.url; });
      $('[data-emc-s-img]').src = pick.img || '';
      $('[data-emc-s-title]').textContent = pick.title;
      $('[data-emc-s-price]').textContent = money(pick.price);
      var btn = $('[data-emc-s-add]');
      btn.dataset.variant = pick.variant;
      btn.dataset.title = pick.title;
    } else { sug.hidden = true; }

    /* totals */
    var orig = $('[data-emc-orig]');
    $('[data-emc-total]').textContent = money(cart.total_price);
    var saving = $('[data-emc-saving]');
    if (cart.total_discount > 0) {
      orig.hidden = false; orig.textContent = money(cart.original_total_price);
      saving.hidden = false; saving.textContent = cfg.msg.saving.replace('[amount]', money(cart.total_discount));
    } else { orig.hidden = true; saving.hidden = true; }
  }

  function refreshAndOpen(){
    return nativeFetch(cfg.root.replace(/\/?$/, '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){ render(cart); open(); })
      .catch(function(){});
  }

  $('[data-emc-s-add]').addEventListener('click', function(){
    var btn = this;
    btn.setAttribute('aria-busy', 'true');
    lastAddedTitle = btn.dataset.title || '';
    fetch(cfg.root.replace(/\/?$/, '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] })
    }).finally(function(){ btn.removeAttribute('aria-busy'); });
  });

  /* Detect every successful add-to-cart, whatever triggered it */
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function(input, init){
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var p = nativeFetch(input, init);
    if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url.split('#')[0])) {
      p.then(function(res){
        if (!res.ok) return;
        res.clone().json().then(function(data){
          var items = data && (data.items || (data.product_title ? [data] : null));
          if (items && items.length && !lastAddedTitle) lastAddedTitle = items.map(function(i){ return i.product_title; }).join(' + ');
        }).catch(function(){}).then(function(){ refreshAndOpen().then(function(){ lastAddedTitle = ''; }); });
      }).catch(function(){});
    }
    return p;
  };
  window.EMCart = { open: refreshAndOpen, close: close };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initEml(root){
    var scope = root.querySelector ? (root.classList && root.classList.contains('eml') ? root : root.querySelector('.eml')) : null;
    if (!scope || scope.dataset.emlReady) return;
    scope.dataset.emlReady = '1';
    document.documentElement.classList.add('js-eml');

    /* scroll reveal */
    var revealEls = scope.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealEls.forEach(function(el){ io.observe(el); });
    } else { revealEls.forEach(function(el){ el.classList.add('is-in'); }); }

    /* guide finder */
    var tabs = scope.querySelectorAll('[data-eml-need]');
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var id = tab.dataset.emlNeed;
        tabs.forEach(function(t){ t.setAttribute('aria-selected', String(t === tab)); });
        scope.querySelectorAll('[data-eml-panel]').forEach(function(p){
          var on = p.dataset.emlPanel === id;
          p.hidden = !on; p.classList.toggle('is-active', on);
        });
        if (window.matchMedia('(max-width:700px)').matches) tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });

    /* filters */
    var fbtns = scope.querySelectorAll('[data-eml-filter]');
    fbtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        var f = btn.dataset.emlFilter;
        fbtns.forEach(function(b){ b.setAttribute('aria-pressed', String(b === btn)); });
        scope.querySelectorAll('[data-eml-cat]').forEach(function(card){
          var c = card.dataset.emlCat;
          card.hidden = !(f === 'all' || c === f || c === 'both');
          if (!card.hidden) { card.classList.add('is-in'); card.animate && card.animate([{opacity:0,transform:'translateY(14px)'},{opacity:1,transform:'none'}],{duration:420,easing:'cubic-bezier(.2,.7,.2,1)'}); }
        });
      });
    });

    /* add to cart */
    scope.querySelectorAll('[data-em-add]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.getAttribute('aria-busy') === 'true') return;
        var ids = btn.dataset.emAdd.split(',').filter(Boolean);
        var label = btn.innerHTML;
        btn.setAttribute('aria-busy', 'true');
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: ids.map(function(id){ return { id: Number(id), quantity: 1 }; }) })
        }).then(function(r){ if (!r.ok) throw r; return r.json(); }).then(function(){
          btn.classList.add('is-added');
          btn.innerHTML = '✓ ' + (scope.dataset.addedLabel || 'Added');
          if (!window.EMCart) window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
          setTimeout(function(){ btn.classList.remove('is-added'); btn.innerHTML = label; btn.removeAttribute('aria-busy'); }, 2200);
        }).catch(function(){ btn.removeAttribute('aria-busy'); window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; });
      });
    });

    /* spotlight tilt */
    var tilt = scope.querySelector('[data-eml-tilt]');
    if (tilt && window.matchMedia('(hover:hover) and (prefers-reduced-motion:no-preference)').matches) {
      tilt.addEventListener('pointermove', function(e){
        var r = tilt.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        tilt.style.setProperty('--ry', ((x - .5) * 18).toFixed(2) + 'deg');
        tilt.style.setProperty('--rx', ((.5 - y) * 14).toFixed(2) + 'deg');
        tilt.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        tilt.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      });
      tilt.addEventListener('pointerleave', function(){ ['--ry','--rx','--mx','--my'].forEach(function(p){ tilt.style.removeProperty(p); }); });
    }

    /* mobile sticky bar: show after hero, hide near finder/footer */
    var sticky = scope.querySelector('[data-eml-sticky]');
    var hero = scope.querySelector('.eml-hero');
    var finder = scope.querySelector('#finder');
    var finalBox = scope.querySelector('.eml-final');
    if (sticky && hero && 'IntersectionObserver' in window) {
      var state = { hero: true, finder: false, fin: false };
      var upd = function(){ var on = !state.hero && !state.finder && !state.fin; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', String(!on)); var a = sticky.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1; };
      var so = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.target === hero) state.hero = e.isIntersecting;
          if (e.target === finder) state.finder = e.isIntersecting;
          if (e.target === finalBox) state.fin = e.isIntersecting;
        });
        upd();
      });
      so.observe(hero); if (finder) so.observe(finder); if (finalBox) so.observe(finalBox);
    }
  }
  initEml(document);
  document.addEventListener('shopify:section:load', function(e){ initEml(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expert-manuals-home"] && !Shopify.designMode) return;
  try {
    
function setupPetFilters(root) {
  root.querySelectorAll('[data-pet-filter]').forEach(button => {
    if (button.dataset.petBound) return;
    button.dataset.petBound = 'true';
    button.addEventListener('click', () => {
      const scope = button.closest('.pets-home');
      const filter = button.dataset.petFilter;
      scope.querySelectorAll('[data-pet-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      scope.querySelectorAll('[data-pet-category]').forEach(card => { card.hidden = filter !== 'all' && card.dataset.petCategory !== filter; });
    });
  });
}
setupPetFilters(document);
document.addEventListener('shopify:section:load', event => setupPetFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
